import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteAdmin } from 'api/admin.service';
import { clearPermissionStore } from 'store/permission';
import { AxiosError } from 'axios';
import { useToast } from 'hooks/ui';

export const useAdminDeleteQuery = () => {
  const toast = useToast();
  const queryClient = useQueryClient();

  const { isPending, mutate } = useMutation({
    mutationFn: ({ id }: { id: string }) => deleteAdmin(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admins'] });
      clearPermissionStore();
      toast.success('Admin has been deleted successfully');
    },
    onError: (error: AxiosError) => {
      toast.error(error.message);
    },
  });

  return { isLoading: isPending, mutate };
};
